import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from 'react-router-dom';
import { Button, Box } from '@mui/material';

import Table from '@mui/material/Table';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';


import DeleteIcon from '@mui/icons-material/Delete';

import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
function AllEvents() {
    const location = useLocation();
    const currentPath = location.pathname;
    const eventid = localStorage.getItem('eventid')
    const [loading, setloading] = useState(false);
    const [eventlist, setEventlist] = useState([]);
    const authName = localStorage.getItem('auth_name');
    const theme = useTheme();

    //const isMobile = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    useEffect(() => {
        axios.get(`api/event`).then(res => {
            if (res.status === 200) {


                setEventlist(res.data.allEvent);


            }
            else {
                setloading(false);
            }


        });

    }, []);

    const eventDelete = (e, id) => {

        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."

        axios.get(`api/deleteEvent/${id}`).then(res => {

            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();

            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });

    }
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup?.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toISOString().split('T')[0];
    };

    const role = localStorage.getItem('role')
    var evanetDataShowInTable = '';
    if (loading) {
        return <h1>Loading Events...</h1>
    }
    else {
        evanetDataShowInTable =
            eventlist.map((item, index) => {
                return (
                    <TableRow

                        key={item.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>


                        <TableCell >{index + 1}</TableCell>
                        <TableCell component="th" scope="row">
                            {item.eventname}
                        </TableCell>
                        <TableCell component="th" scope="row">
                            {item.eventstart ? item.eventstart : formatDate(item.created_at)}
                        </TableCell>
                        <TableCell align="right">

                            <Button sx={{
                                marginRight: '10px',
                                marginTop: '2%',
                                backgroundColor: backGroundButtonByEvent,
                                ":hover": {
                                    color: "white",

                                }
                            }}
                                color='primary'
                                size='small'
                                variant='contained'
                                component={Link}
                                to={`/admin/dashbord/${item.id}`}>
                                <VisibilityIcon />
                            </Button>
                            {role === "superadmin" ?
                                <Button sx={{
                                    marginRight: '11%',
                                    marginTop: '2%',
                                    ":hover": {
                                        color: "white"
                                    }
                                }}
                                    color='primary'
                                    size='small'
                                    variant='contained'

                                    onClick={(e) => eventDelete(e, item.id)}
                                >
                                    <DeleteIcon />
                                </Button> : ""}

                        </TableCell>
                    </TableRow>
                )

            });
    }

    return (
        <div style={{ margin: '1%', }}>

            <Box sx={{ color: '#000000', }} style={{ marginTop: '7%' }}>

                <h4 sx={{ m: 2, color: '#000000' }}>Event Management
                    {role === "superadmin" ?
                        <Button sx={{
                            float: 'right',

                            marginTop: '2%',
                            ":hover": {
                                color: "white"
                            }
                        }}
                            color='primary'
                            size='small'
                            variant='contained'
                            component={Link}
                            to="#">
                            Add EventS
                        </Button> : ""}
                </h4>
                <Card sx={{ width: '80vw', float: 'center' }} >
                    <CardContent >

                        {
                            isSmallScreen ? (
                                <div>
                                    <Typography variant="h5" component="div" sx={{ fontSize: 20, textAlign: 'center', color: '#000000' }}>
                                        Event Management
                                    </Typography>
                                    {/* Displaying event list in a more mobile-friendly format */}
                                    {eventlist.length > 0 ? (
                                        eventlist.map((item, index) => (
                                            <Box key={item.id} sx={{ padding: '16px', border: '1px solid #ddd' , mt:5 }}>
                                                <Typography variant="body1" sx={{ mt:1 , mb:2}}>{index + 1}. {item.eventname}</Typography>
                                                <Typography variant="body2" color="textSecondary">{item.eventstart ? item.eventstart : formatDate(item.created_at)}</Typography>
                                                <Button
                                                    sx={{
                                                        backgroundColor: backGroundButtonByEvent,
                                                        color: 'white',
                                                        marginTop: '8px',
                                                        marginLeft: 'auto', // Push the button to the right side
                                                        display: 'flex',   // Make it a flex item to align it properly
                                                        alignItems: 'center', // Align the icon in the center vertically
                                                    }}
                                                    variant="contained"
                                                    size="small"
                                                    component={Link}
                                                    to={`/admin/dashbord/${item.id}`}>
                                                    <VisibilityIcon />
                                                </Button>
                                                {role === "superadmin" && (
                                                    <Button
                                                        sx={{ backgroundColor: 'red', color: 'white', marginTop: '8px', marginLeft: '8px' }}
                                                        variant="contained"
                                                        size="small"
                                                        onClick={(e) => eventDelete(e, item.id)}>
                                                        <DeleteIcon />
                                                    </Button>
                                                )}
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography>No events available.</Typography>
                                    )}
                                </div>
                            ) : (
                                <TableContainer>
                                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow sx={{ color: '#FFFFFF' }}>
                                                <TableCell>#</TableCell>
                                                <TableCell>Event Name</TableCell>
                                                <TableCell>Date</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {evanetDataShowInTable}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )
                        }



                        {eventlist == "" ?
                            <Typography
                                component="h2" style={{ color: "#311b92", padding: 50, lineHeight: 2, }}>
                                <Badge badgeContent={'Note::'} color="secondary" >
                                </Badge> &emsp;&nbsp;
                                {" Dear " + authName + `, If you are not able to see the event to submit your abstract here, 
                         you probably came through a wrong link. Please contact us with 
                         your email ID or whatsapp +966565612058 , support@microartonline.com to assign you the event.`}
                            </Typography> : ""}
                    </CardContent>
                </Card>
            </Box>

        </div>
    )
}

export default AllEvents
